export { default } from "@workspace/gamja-platform/components/problem-answer";
export type { ProblemAnswerProps } from "@workspace/gamja-platform/components/problem-answer";
